import { CSSProperties, forwardRef } from 'react';
import clsx from 'clsx';
import { GenericKeyValueType } from '../shared/interfaces/generics';

export interface HevoIconProps extends GenericKeyValueType<string, unknown> {
  name: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
  dataId?: string;
}

export const Icon = forwardRef<HTMLSpanElement, HevoIconProps>(
  ({ name, size, className = '', dataId = '', ...props }: HevoIconProps, ref) => (
    <span
      ref={ref}
      data-id={dataId}
      className={clsx(
        `hevo-icon hevo-${name}`,
        Number.isInteger(size) && `icon-size-${size}`,
        className
      )}
      {...props}
    />
  )
);
